module.exports = __webpack_public_path__ + "img/lock_done.6fc78073.svg";